import { postFormData, postJson } from '../../../composables/useApi';
import type { ApiConfig } from '../../../composables/useApi';

export type ExistingImagePayload = {
  id?: string;
  filename?: string;
  url: string;
  position: number;
  is_cover: number;
};

export const imagesApi = {
  async upload(api: ApiConfig, params: { file: File; offerId: number; position: number; is_cover: number }) {
    const fd = new FormData();
    fd.append('file', params.file);
    fd.append('offerId', String(params.offerId));
    fd.append('position', String(params.position));
    fd.append('is_cover', String(params.is_cover));
    await postFormData(api.apiUploadImage, fd);
  },

  async persistOrder(api: ApiConfig, offerId: number, images: ExistingImagePayload[]) {
    await postJson(api.apiUpdate, { id: offerId, images });
  },
};
